import Template from './Template'
import Slot from "./Slot";
import Webview from "../native/visible/Webview";

class MultipleOfferTemplate extends Template{
    constructor(props = {}) {
        super(props)
        this.campaignList = props.campaignList || []
    }

    /**
     * 初始化模板包含的各个组件
     */
    initComponents() {
        if(!this.container){
            this.container = new Webview()
        }
    }

    /**
     * 给大模板动态添加插槽
     * @param params
     */
    addSlot(params={rect:undefined, component:undefined, id:undefined}){
        const slot = Slot.getSlot()
        this.slotList.push(slot)
    }

    /**
     * 子类需要重写该方法，以判断模板的是否成功加载
     * @returns {Promise}
     */
    _isLoadFinish(){
        return super._isLoadFinish()
    }
}
export default MultipleOfferTemplate